export const POST_AUTH_ROUTE_KEY = "pullpress_post_auth_route";

export function storePostAuthRoute(route: string | undefined): void {
  if (!isLocalRoute(route)) return;
  writeStorage(window.sessionStorage, route);
  writeStorage(window.localStorage, route);
}

export function consumePostAuthRoute(): string | null {
  const route = readStorage(window.sessionStorage) ?? readStorage(window.localStorage);
  removeStorage(window.sessionStorage);
  removeStorage(window.localStorage);
  return isLocalRoute(route) ? route : null;
}

function isLocalRoute(route: string | null | undefined): route is string {
  return typeof route === "string" && route.startsWith("/") && !route.startsWith("//");
}

function writeStorage(storage: Storage, route: string): void {
  try {
    storage.setItem(POST_AUTH_ROUTE_KEY, route);
  } catch {
    /* Some browsers can deny storage during OAuth handoff. */
  }
}

function readStorage(storage: Storage): string | null {
  try {
    return storage.getItem(POST_AUTH_ROUTE_KEY);
  } catch {
    return null;
  }
}

function removeStorage(storage: Storage): void {
  try {
    storage.removeItem(POST_AUTH_ROUTE_KEY);
  } catch {
    /* Storage removal failure is non-fatal. */
  }
}
